import { createSlice } from '@reduxjs/toolkit';

// Initial state for profile
const initialState = {
    profile: null,
    size: null, // Add size to the initial state
    shirtSize: '',
    address: null,
    mappedDefaultColor: null,
    alterAcc: null,

};

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        // Action to set profile data
        setProfile: (state, action) => {
            state.profile = action.payload;
        },
        // Action to clear profile data (optional)
        clearProfile: (state) => {
            state.profile = null;
        },
        // Action to set size value
        setSize: (state, action) => {
            state.size = action.payload;
        },
        setShirtSize: (state, action) => { // Add this reducer
            state.shirtSize = action.payload;
        },
        // Action to clear size value (optional)
        clearSize: (state) => {
            state.size = null;
        },
        updateAddress: (state, action) => {
            state.address = action.payload;
        },
        setMappedDefaultColor: (state, action) => {
            state.mappedDefaultColor = action.payload;
        },
        setAccountData: (state, action) => {
            state.alterAcc = action.payload;
        },

    },
});

export const { setProfile, clearProfile, setSize, clearSize, setShirtSize, setAccountData, updateAddress, setMappedDefaultColor } = profileSlice.actions;

export default profileSlice.reducer; // This exports the reducer